import { render } from "./NotFound.vue?vue&type=template&id=b409b7f0&scoped=true&ts=true"
import script from "./NotFound.ts?vue&type=script&lang=ts"
export * from "./NotFound.ts?vue&type=script&lang=ts"

import "./NotFound.scss?vue&type=style&index=0&id=b409b7f0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b409b7f0"]])

export default __exports__